import {Component, ChangeDetectionStrategy} from '@angular/core';
import {AbstractKeyboard} from 'app/drawing/component/keyboards/abstract-keyboard.class';

@Component({
    selector: 'app-calculator',
    templateUrl: './calculator.component.html',
    styleUrls: [
        './calculator.component.scss',
        '../abstract-keyboard.styles.scss',
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class CalculatorComponent extends AbstractKeyboard {}
